module.exports = __webpack_public_path__ + "static/media/state-12.7facc55e.jpg";